// external libs
import { combineEpics } from 'redux-observable'

// epics
import ProductEpic from '../Core/Epics/ProductEpic'
import CalculatorEpic from '../Core/Epics/CalculatorEpic'
import QuoteEpic from '../Core/Epics/QuoteEpic'
import ContentEpic from '../Core/Epics/ContentEpic'
import DiscountsEpic from '../Core/Epics/DiscountsEpic'
import OfferEpic from '../Core/Epics/OfferEpic'
import LeavingScreenEpic from './LeavingScreenEpic'

import generalEpic from './general'
import productEpic from './product'

const epics = [
  ...ProductEpic,
  ...CalculatorEpic,
  ...QuoteEpic,
  ...ContentEpic,
  ...DiscountsEpic,
  ...OfferEpic,
  ...generalEpic,
  ...productEpic,
  ...LeavingScreenEpic,
]

const rootEpic = combineEpics(...epics)

export default rootEpic
